module.exports = __webpack_public_path__ + "static/damera-gardens-rera_page-0002-87ecf7cd5d2f0b45ce77230d1b563e6a.jpg";